import type { FaireProductEntity } from "../../entity_types/product";

export const p_uf2qwg9hza: FaireProductEntity = {
  token: "p_uf2qwg9hza",
  type: "product",
  name: "Striped Relaxed Fit Knit Tee",
  brandToken: "b_q33jfvrznn",
  brandName: "Sewn and Seen",
  imageUrl:
    "https://cdn.faire.com/fastly/4258e5c5bd9b1fb0107698a2e8d35822952a86a5d706e55aaa5bb9ad2bd8b578.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1f73b25861a7178654257a47549397c50a2855bfa33ae648d0263eaaf2849d91.jpeg",
    "https://cdn.faire.com/fastly/f788dee22bd159d5c21ed18251a16138c309d8668cc9cfd3b405355d822af11b.jpeg",
    "https://cdn.faire.com/fastly/856ea4468ea9077ff39973fa4da0fa08660c38a32af277a82d34734c9ed9ed68.jpeg",
    "https://cdn.faire.com/fastly/2df322cd1143d3560a1a69f944ed22f62188fa4987e3e434c524c56384813b3a.jpeg",
    "https://cdn.faire.com/fastly/798fbec36f92562b8f0ef7d978ed71ba78351d9d78a32dde68f2590f5119df65.jpeg",
    "https://cdn.faire.com/fastly/2b37312fbb8b8e56b3ee3a98ce31d959dae0b697445ba8f5928b59c2c2709f27.jpeg",
    "https://cdn.faire.com/fastly/9a1d49b100406f8a4343b707ebcd429d9227ec923b65b09df351be3dce5c0e32.jpeg",
    "https://cdn.faire.com/fastly/45170c325135c686ee673cb4f60d6815ecdd8d484ddf4388e41be30c9f2e73a5.jpeg",
    "https://cdn.faire.com/fastly/a1fe90ae052dfc832f562166d4659189fa5081862ffe7d867d7664776727bcfa.jpeg",
    "https://cdn.faire.com/fastly/0d8d52b9c7721413d36ba642a85aec8070a99e79b263291ae0ab2d5271a01c41.jpeg",
    "https://cdn.faire.com/fastly/90b86d9a9ad0f5aac71d7db334686498b13e75bc98e8f1223077e71bdbe9190d.jpeg",
    "https://cdn.faire.com/fastly/dc6f36a0c0869ae570642401b93971a53950112aa9f0bf1b89657f64bf39357d.jpeg",
    "https://cdn.faire.com/fastly/921329de5c95038e507b718d154d4d7eb544a89190cc222a8e6adfd4a7239c50.jpeg",
    "https://cdn.faire.com/fastly/67e76f3be04021ec37f8997f5623c38d6a398514faa9d0ad7b22bf65af749183.jpeg",
    "https://cdn.faire.com/fastly/26e126d6cff6e569f053635d32d2264b16f70e0ac13401f7ae72e413bc6fa4ce.jpeg",
  ],
  priceDollars: 107.7,
  description:
    "This striped relaxed fit tee is designed for effortless everyday comfort with a modern relaxed fit. Made from soft knit fabric, it offers a lightweight and breathable feel that is perfect for casual wear. The loose silhouette with drop shoulders creates an easy, laid-back look, while the classic stripe pattern adds a timeless touch. Finished with subtle side slits for added movement and style, this versatile top pairs perfectly with denim, shorts, or lounge bottoms for an easy boutique-ready outfit. striped oversized tee, striped knit top, casual striped shirt, oversized casual tee, boutique striped top, relaxed fit striped tee, everyday basic top, soft knit striped shirt, trendy casual top, comfortable oversized tee",
  tags: [],
  msrpDollars: 215.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:24:22.692Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
